import {
  AUTO_ACTIVATION_REASON_CODES,
  AUTO_ACTIVATION_SOURCES,
  type AutoActivationReasonCode,
  type AutoActivationSource,
  PHONE_STANDING_CONSENT_GRANT_SOURCES,
  type PhoneStandingConsentGrantSource,
} from './auto-activation.constants';

const AUTO_ACTIVATION_REASON_CODE_SET = new Set<string>(
  AUTO_ACTIVATION_REASON_CODES,
);

const AUTO_ACTIVATION_SOURCE_SET = new Set<string>(AUTO_ACTIVATION_SOURCES);

const PHONE_STANDING_CONSENT_GRANT_SOURCE_SET = new Set<string>(
  PHONE_STANDING_CONSENT_GRANT_SOURCES,
);

export function isAutoActivationReasonCode(
  value: unknown,
): value is AutoActivationReasonCode {
  return (
    typeof value === 'string' && AUTO_ACTIVATION_REASON_CODE_SET.has(value)
  );
}

export function parseAutoActivationReasonCode(
  value: unknown,
): AutoActivationReasonCode | null {
  return isAutoActivationReasonCode(value) ? value : null;
}

export function isAutoActivationSource(
  value: unknown,
): value is AutoActivationSource {
  return typeof value === 'string' && AUTO_ACTIVATION_SOURCE_SET.has(value);
}

export function parseAutoActivationSource(
  value: unknown,
): AutoActivationSource | null {
  return isAutoActivationSource(value) ? value : null;
}

export function isPhoneStandingConsentGrantSource(
  value: unknown,
): value is PhoneStandingConsentGrantSource {
  return (
    typeof value === 'string' &&
    PHONE_STANDING_CONSENT_GRANT_SOURCE_SET.has(value)
  );
}

export function parsePhoneStandingConsentGrantSource(
  value: unknown,
): PhoneStandingConsentGrantSource | null {
  return isPhoneStandingConsentGrantSource(value) ? value : null;
}
